import { LINK_ATTACHMENTS } from "../api/urls";
import { IContact } from "./contacts";
import { differenceInHours } from "date-fns";

/* ============================================================
   BACKEND → FRONTEND
   ============================================================ */
export interface ISession {
  id: number; //PK da tabela message
  idEnterprise: number;
  idUser: number;
  idContact: number;
  isActive: boolean | number;
  isAiActive: boolean | number;
  aiCurrentStep: number;
  aiFallbackToHuman: boolean | number;
  aiInactivityLevel: number;
  createdAt: string;
  closedAt: string;
  aiLastInteraction: string;
}

export interface IMessage {
  id: number; //PK da tabela message
  messageId: string; //Chave que liga na META
  idContact: number;
  idSession: number;
  isRead: number; //0=Nao lida, 1=Lido
  isForwarded: number;
  isFromContact: boolean;
  type: string;
  body: string;
  status: string | null;
  createdAt: string;
  updatedAt: string;
  reaction: string | null;

  //NotMapped
  idEnterprise?: number;
  idUser?: number;
  idUserMain?: number;
}

/* ============================================================
   UI DO CHAT (DootChat)
   ============================================================ */

export interface IAttachment {
  id: number;
  idMessage: number;
  idGraph: string;
  fileName: string;
  filePath: string;
  mimeType: string;
  fileSize: number;
  caption: string | null;

  //NotMapped
  idEnterprise?: number;
  idUser?: number;
  idUserMain?: number;
}

export interface IMessagesTypes {
  mId: number; //PK da tabela message
  messageId?: string; // ← ADICIONE ISSO
  contactId: number;
  type?: string;
  text?: string;
  time: string;
  isRead?: number;
  contactName: string | null | undefined;

  //NotMapped
  idEnterprise?: number;
  idUser?: number;
  idUserMain?: number;

  meta: {
    receiver: string | number;
    sender: string | number;
    userData?: IContact;
    sent: boolean;
    received: boolean;
    read: boolean;
    isForwarded?: boolean;
  };

  reaction: string | null;
  attachments?: IAttachmentTypes[];
  image?: IImageTypes[];
  newimage?: IImageTypes[];
  replyOf?: IMessagesTypes;
}

/* ============================================================
   MAPEAMENTO
   ============================================================ */
export function mapMessagesToMessagesTypes(list: IMessage[]): IMessagesTypes[] {
  return list.map(m => mapMessageToMessageTypes(m));
}

export function mapMessageToMessageTypes(m: IMessage): IMessagesTypes {
  return {
    mId: m.id,
    contactId: m.idContact,
    messageId: m.messageId, // 👈 ESSENCIAL

    type: m.type,
    text: m.body,
    time: m.createdAt,
    isRead: m.isRead,

    contactName: null,
    reaction: m.reaction,

    //NotMapped
    idEnterprise: m.idEnterprise,
    idUser: m.idUser,
    idUserMain: m.idUserMain,

    meta: {
      sender: m.isFromContact === true ? 1 : 0, //0=Cliente 1=Usuario
      receiver: m.isFromContact === true ? 0 : 1, //0=Cliente para Usuario, 1=Usuario para cliente
      sent: m.status === "sent" || true,
      received: m.status === "received" || true,
      read: m.isRead === 1,
      isForwarded: m.isForwarded === 1,
    },

    attachments: [],
    image: [],
    newimage: [],
  };
}

export interface IImageTypes {
  id: number;
  downloadLink: string;
  caption: string | null;
}

export interface IAttachmentTypes {
  id: number;
  name: string;
  downloadLink: string;
  desc: string;
  mimeType: string;
}

export const mapImageToTypes = (a: IAttachment): IImageTypes => ({
  id: a.id,
  caption: a.caption,
  downloadLink: getDownloadPathFile(a.fileName),
});

const getDownloadPathFile = (name: string) => {
  // console.log("getDownloadPathFile", getDownloadPathFile);
  const ext = name.split(".").pop()?.toLowerCase();
  switch (ext) {
    case "png":
    case "jpg":
    case "jpeg":
    case "webp":
      return LINK_ATTACHMENTS + "image/" + name;
    case "mp4":
      return LINK_ATTACHMENTS + "video/" + name;
    case "ogg":
      return LINK_ATTACHMENTS + "audio/" + name;
    case "dat":
      return LINK_ATTACHMENTS + "sticker/" + name;
    default:
      return LINK_ATTACHMENTS + "document/" + name;
  }
};

export const mapAttachmentToTypes = (a: IAttachment): IAttachmentTypes => {
  // console.log(
  //   "%c🧩 [mapAttachmentToTypes]",
  //   "color: #7c4dff; font-weight:bold;",
  //   {
  //     id: a.id,
  //     fileName: a.fileName,
  //     mimeType: a.mimeType,
  //     caption: a.caption,
  //     original: a,
  //   },
  // );

  return {
    id: a.id,
    name: a.fileName,
    downloadLink: getDownloadPathFile(a.fileName),
    desc: a.caption ?? "",
    mimeType: a.mimeType,
  };
};

export function parseLocation(body: string) {
  const parts = body.split("||");

  const line1 = parts[0] ?? "";
  const url = parts[1]?.trim() ?? "";
  const coords = parts[2]?.trim() ?? "";

  // Extrair latitude e longitude
  let latitude = null;
  let longitude = null;

  if (coords.includes(",")) {
    const [lat, lng] = coords.split(",");
    latitude = parseFloat(lat);
    longitude = parseFloat(lng);
  }

  return {
    text: line1.trim(),
    url,
    latitude,
    longitude,
  };
}

export const isWithin24Hours = (lastContactMessageTime?: string) => {
  if (!lastContactMessageTime) return false;

  const last = new Date(lastContactMessageTime);
  const now = new Date();

  return differenceInHours(now, last) < 24;
};

export interface QuickReply {
  id: number;
  name: string;
  description: string;
}

export const getFileNameFromUrl = (url: string): string => {
  return url.split("/").pop() ?? "";
};

export const getFileIcon = (fileName: string): string => {
  const ext = fileName.split(".").pop()?.toLowerCase();

  switch (ext) {
    case "pdf":
      return "bx bxs-file-pdf";
    case "doc":
    case "docx":
      return "bx bxs-file-doc";
    case "xls":
    case "xlsx":
      return "bx bxs-file";
    case "png":
    case "jpg":
    case "jpeg":
      return "bx bxs-image";
    default:
      return "bx bxs-file";
  }
};
